export interface PostRequestPayload {
  groupRegistrationId: string;
  groupId: string;
  invitedUserId: string;
}

export const TOURNAMENT_PARTNER_REQUEST_API =
  '/v1/tournaments/[tournamentId]/partner-request';

export const getTournamentPartnerRequestApi = (tournamentId: string) =>
  `/v1/tournaments/${tournamentId}/partner-request`;

export interface AcceptDenyRequestPayload {
  invitationId: string;
}

export const getTournamentPartnerRequestAcceptApi = (tournamentId: string) =>
  `/v1/tournaments/${tournamentId}/partner-request/accept`;

export const getTournamentPartnerRequestDenyApi = (tournamentId: string) =>
  `/v1/tournaments/${tournamentId}/partner-request/deny`;
